import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-269ede2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "props-name" }
const _hoisted_2 = {
  key: 0,
  class: "price"
}
const _hoisted_3 = {
  key: 1,
  class: "props-name",
  style: {"color":"#B0B7C2"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/icon_open.png",
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_5 = {
  class: "choose-sku",
  style: {"height":"282px"}
}
const _hoisted_6 = { class: "sku-type-title" }
const _hoisted_7 = { class: "sku-type-content" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "props-item-content" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/check_active.png",
  alt: "",
  class: "check"
}, null, -1))
const _hoisted_12 = { class: "sku-btn" }
const _hoisted_13 = {
  key: 1,
  style: {"line-height":"48px","padding-left":"20px"}
}

import { t } from '@/plugins/i18n'
import { computed, ref, watch, onMounted } from 'vue'
import { arr2map } from '@/plugins/utils'
import bus from '@/util/useBus'
import confirmDialog from '@/components/common/ConfirmDialog'
import Image from '@/components/common/Image.vue'
import { useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { formatCountryMoney, showCurrentUnit } from '@/util/useYan'
import { isJA } from '@/store'
import { codeName } from '@/components/BlackGoods/data'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  props: ['product', 'activeItem', 'shopItemSkuId', 'productIndex', 'shopIndex', 'change', 'skuMapping'],
  setup(__props) {

const props = __props
const store = useStore()

const route = useRoute()
const dropdownRef = ref()
const propKeys: any = ref([])
const activeSkuInfo: any = ref({})
const show = ref(false)
const isShowSku = computed(() => {
  const sku = store.getters['goods/getSku']
  return sku ? sku === props.activeItem?.productSku : false
})
// 绑定时高亮展示
const activeShopSkuId = ref('')
const isdisabled = (v: string, i: number) => {
  if (propKeys.value.includes(v)) return false
  if (!propKeys.value.length || propKeys.value.filter(i => !!i).length < props.product.productPropGroupList.length - 1) return false
  const key = [...propKeys.value?.slice(0, i), v, ...propKeys.value?.slice(i + 1)].join(';')
  return !props.skuMapping.get(key)
}

watch(() => props.activeItem, () => {
  activeSkuInfo.value = props.product?.skuList?.find((i: { productSku: string }) => i.productSku === props.activeItem?.productSku) ?? {}
  propKeys.value = activeSkuInfo.value.productProperties?.split(';') ?? []
  console.log(activeSkuInfo, 'activeSkuInfo');

}, {
  immediate: true,
  deep: true
})
const changeVisible = (visible: boolean) => {
  show.value = visible
  if (visible) {
    // 编辑sku
    bus.emit('createAssociatedEditProductSku', props.shopItemSkuId)
  } else {
    bus.emit('createAssociatedEditProductSku', '')
  }
  propKeys.value = activeSkuInfo.value.productProperties?.split(';') ?? []
}

bus.on('createAssociatedEditProductSku', (sku) => {
  activeShopSkuId.value = sku
})
const bindSkuItem = () => {
  const newSku = props.skuMapping.get(propKeys.value.join(';')).productSku
  if (newSku === activeSkuInfo.value.productSku) {
    dropdownRef.value.handleClose()
    return
  }
  // if (props.product?.blackTag === 1) {
  //   ElMessage.warning(codeName[props.product.blackReasonCode]?.strict || t('黑名单商品不允许关联商品'))
  //   return
  // }
  props.change({
    productIndex: props.productIndex,
    shopSkuIndex: props.shopIndex,
    productSku: newSku
  })
  bus.emit('createAssociatedEditProductSku', '')
  dropdownRef.value.handleClose()
}
const unBind = () => {
  confirmDialog({
    title: t('提示'),
    text: t('是否解绑'),
    htmlNode: true,
    okText: t('确认'),
    cancelText: t('关闭'),
    closeOnClickModal: false
  }).then(() => {
    if (props.activeItem?.productSku) {
      props.change({
        productIndex: props.productIndex,
        shopSkuIndex: props.shopIndex,
        productSku: '',
        isUnbind: true
      })
    }
    bus.emit('createAssociatedEditProductSku', '')
  })
}
const chooseSkuItem = (temp: any, index: number) => {
  if (isdisabled(temp.propKey, index)) return
  propKeys.value[index] = propKeys.value.includes(temp.propKey) ? '' : temp.propKey
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sku-item", { odd: (__props.shopIndex % 2 === 1) }])
  }, [
    (__props.product.productTitle !== 'test')
      ? (_openBlock(), _createBlock(_component_el_dropdown, {
          key: 0,
          trigger: "click",
          onVisibleChange: changeVisible,
          ref: (_value, _refs) => {
            _refs['dropdownRef'] = _value
            dropdownRef.value = _value
          }
        }, {
          dropdown: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (show.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_scrollbar, { style: {"height":"200px"} }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.productPropGroupList, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "sku-type",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(item.type), 1),
                            _createElementVNode("div", _hoisted_7, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.props, (temp, key) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["props-item", {
                    disabled: isdisabled(temp.propKey, index),
                    active: temp.propKey === propKeys.value[index]
                  }]),
                                  key: key,
                                  onClick: ($event: any) => (chooseSkuItem(temp, index))
                                }, [
                                  _createElementVNode("div", _hoisted_9, [
                                    (temp.url)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: temp.url,
                                          alt: "",
                                          class: "goods-img"
                                        }, null, 8, _hoisted_10))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(temp.propValue), 1)
                                  ]),
                                  _hoisted_11
                                ], 10, _hoisted_8))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_12, [
                      (props.activeItem?.productSku)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            class: "btn",
                            onClick: unBind
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('解绑')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        class: "btn",
                        onClick: bindSkuItem,
                        disabled: props.productIndex > 29 || (propKeys.value?.filter(i => !!i)?.length !== props.product?.productPropGroupList?.length)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('绑定')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["sku-item-link flex-center", { active: (__props.shopItemSkuId === activeShopSkuId.value), flicker: _unref(isShowSku) }])
            }, [
              (__props.activeItem?.productSku)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(Image, {
                      src: activeSkuInfo.value.productSkuImg || __props.product.productMainImg,
                      class: "sku-img"
                    }, null, 8, ["src"]),
                    _createVNode(_component_el_tooltip, {
                      placement: "top-start",
                      effect: "light",
                      content: ((__props.product.useJaGroup ? activeSkuInfo.value.productPropertiesNameJa : activeSkuInfo.value.productPropertiesName) ?? activeSkuInfo.value.productPropertiesName)?.replace(/[+-]?\d+:[+-]?\d+:/ig, ''),
                      "popper-class": "tool-tip-no-border"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(((__props.product.useJaGroup ? activeSkuInfo.value.productPropertiesNameJa :
              activeSkuInfo.value.productPropertiesName) ??
              activeSkuInfo.value.productPropertiesName)?.replace(/[+-]?\d+:[+-]?\d+:/ig, '')), 1)
                      ]),
                      _: 1
                    }, 8, ["content"]),
                    (activeSkuInfo.value.productSellPrice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(activeSkuInfo.value.productSellPrice ?? '-') + _toDisplayString(_unref(showCurrentUnit)((activeSkuInfo.value.productType === 3 ? props.product.goodsCountry : activeSkuInfo.value.country) ===
              _unref(COUNTRY).KR)) + " (" + _toDisplayString(_unref(formatCountryMoney)(activeSkuInfo.value.productSellPrice, activeSkuInfo.value.productType === 3 ?
                (props.product.goodsCountry === _unref(COUNTRY).KR ? 'KRW' : 'CNY') : activeSkuInfo.value.currency)) + ")", 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('请选择')), 1)),
              _hoisted_4
            ], 2)
          ]),
          _: 1
        }, 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, "sku123"))
  ], 2))
}
}

})